export default __webpack_public_path__ + "static/media/boss_dvalin_sigh.5bbde067.png";